// The box plot's value label: a duration in DAYS as the largest unit under one day — `2.5d`,
// `3.0h`, `12.0m`, `30.0s` — or `N/A` for a missing / non-numeric value. VERBATIM from
// issue-analysis's `src/utils/chartUtils.js` (deleted with its BoxPlot at IA_ABSORPTION_PLAN
// Phase 4 step 12d — this was the last function left there). Package-private: the base uses it
// for the value-axis labels and the tooltip; nothing else in either app formats durations.

/**
 * @param {number|string|null|undefined} value  a duration in days
 * @returns {string}
 */
export function formatTimeValue(value) {
  if (value === null || value === undefined || value === 'N/A') {
    return 'N/A';
  }

  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return 'N/A';
  }

  if (numValue < 1) {
    const hours = numValue * 24;
    if (hours < 1) {
      const minutes = hours * 60;
      if (minutes < 1) {
        const seconds = minutes * 60;
        return `${seconds.toFixed(1)}s`;
      }
      return `${minutes.toFixed(1)}m`;
    }
    return `${hours.toFixed(1)}h`;
  }

  return `${numValue.toFixed(1)}d`;
}
